export const DEFAULT_FRENCH_LOCALE = {
  documentTitle: 'Certificate of Italian Language',
  deliverPrefix: 'Delivre à',
  birthLineTemplate: 'née au {{lieuNaissance}} le {{dateNaissance}}',
  bodyTemplate:
    "pour avoir suivi pendant {{dureeCours}} le cours d Italien pour faciliter l'accès aux bibliothèques italiennes et programme d'échanges professionnels organisée dans le cadre de la collaboration existante entre le Centre Interuniversitaire de Recherche Pluridisciplinaire(CIREP) et la Ville de troia",
  dateLineTemplate: 'Fait à {{lieuEmission}} le {{dateEmission}}',
  signature1Name: 'Prof Nizeyimana Jean Baptiste',
  signature1Title: 'Directeur Général CIREP',
  signature2Name: 'Bortone Vincenza',
  signature2Title: 'Formatrice',
  signature3Name: 'Dott. Francesco Caserta',
  signature3Title: 'Maire de la Ville de Troia',
};

export const DEFAULT_ITALIAN_LOCALE = {
  documentTitle: 'Certificato di lingua italiana',
  deliverPrefix: 'Consegnato a',
  birthLineTemplate: '{{birthVerb}} in {{lieuNaissance}} il {{dateNaissance}}',
  bodyTemplate:
    "per aver seguito per {{dureeCours}} il corso di lingua italiana dedicato alla mobilità culturale e all'uso delle biblioteche italiane, organizzato nell'ambito della collaborazione in essere tra il Centro Interuniversitario di Ricerca Multidisciplinare (CIREP) t la Ville de troia",
  dateLineTemplate: 'Fatto a {{lieuEmission}} il {{dateEmission}}',
  signature1Name: 'Prof Nizeyimana Jean Baptiste',
  signature1Title: 'Direttore Generale del CIREP',
  signature2Name: 'Bortone Vincenza',
  signature2Title: 'Formatore',
  signature3Name: 'Dott. Francesco Caserta',
  signature3Title: 'Sindaco del Comune di Troia',
};

export const DEFAULT_ITALIAN_TEMPLATE = {
  leftLogoUrl: '',
  rightLogoUrl: '',
  borderImageUrl: '',
  french: DEFAULT_FRENCH_LOCALE,
  italian: DEFAULT_ITALIAN_LOCALE,
};

const LOCALE_FIELD_KEYS = [
  'documentTitle', 'deliverPrefix', 'birthLineTemplate', 'bodyTemplate', 'dateLineTemplate',
  'signature1Name', 'signature1Title', 'signature2Name', 'signature2Title',
  'signature3Name', 'signature3Title',
];

const pickLocaleFields = (saved) => {
  const picked = {};
  LOCALE_FIELD_KEYS.forEach((key) => {
    if (saved[key] != null) picked[key] = saved[key];
  });
  return { ...DEFAULT_FRENCH_LOCALE, ...picked };
};

export const mergeItalianTemplate = (saved) => {
  if (!saved) return DEFAULT_ITALIAN_TEMPLATE;

  if (saved.french || saved.italian) {
    return {
      ...DEFAULT_ITALIAN_TEMPLATE,
      leftLogoUrl: saved.leftLogoUrl || '',
      rightLogoUrl: saved.rightLogoUrl || '',
      borderImageUrl: saved.borderImageUrl || '',
      french: { ...DEFAULT_FRENCH_LOCALE, ...saved.french },
      italian: { ...DEFAULT_ITALIAN_LOCALE, ...saved.italian },
    };
  }

  return {
    ...DEFAULT_ITALIAN_TEMPLATE,
    leftLogoUrl: saved.leftLogoUrl || '',
    rightLogoUrl: saved.rightLogoUrl || '',
    borderImageUrl: saved.borderImageUrl || '',
    french: pickLocaleFields(saved),
    italian: { ...DEFAULT_ITALIAN_LOCALE, ...saved.italian },
  };
};

export const getItalianLocaleTemplate = (template, locale) => (
  locale === 'it' ? template.italian : template.french
);
